import { Timestamp } from 'firebase/firestore';

export type ActivityCategory =
  | 'hiking'
  | 'sport'
  | 'roadtrip'
  | 'city-tour'
  | 'cultural'
  | 'nightlife'
  | 'food'
  | 'coworking'
  | 'language-exchange'
  | 'other';

export type ActivityStatus = 'open' | 'full' | 'cancelled' | 'completed';

export interface ActivityCommentReply {
  id: string;
  userId: string;
  username: string;
  avatar?: string;
  content: string;
  createdAt: Timestamp;
}

export interface ActivityComment {
  id: string;
  userId: string;
  username: string;
  avatar?: string;
  content: string;
  replies?: ActivityCommentReply[];
  createdAt: Timestamp;
}

export interface ActivityParticipant {
  userId: string;
  username: string;
  avatar?: string;
  joinedAt: Timestamp;
}

export type ActivityDifficulty = 'easy' | 'moderate' | 'challenging';
export type ActivityBudget = 'free' | 'cheap' | 'moderate' | 'expensive';

export interface Activity {
  id: string;
  userId: string;
  username: string;
  userAvatar?: string;
  title: string;
  description: string;
  category: ActivityCategory;
  date: Timestamp;
  time: string;
  city: string;
  country: string;
  countryCode: string;
  meetingPoint?: string;
  maxParticipants: number;
  difficulty?: ActivityDifficulty;
  budget?: ActivityBudget;
  spokenLanguages?: string[];
  requirements?: string;
  participants: ActivityParticipant[];
  comments: ActivityComment[];
  likes: string[];
  favorites: string[];
  status: ActivityStatus;
  isActive: boolean;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export const ACTIVITY_CATEGORIES: { id: ActivityCategory; label: string; icon: string }[] = [
  { id: 'hiking', label: 'Randonnée', icon: 'Mountain' },
  { id: 'sport', label: 'Sport', icon: 'Dumbbell' },
  { id: 'roadtrip', label: 'Road trip', icon: 'Car' },
  { id: 'city-tour', label: 'Visite de la ville', icon: 'MapPin' },
  { id: 'cultural', label: 'Culture & Musée', icon: 'Landmark' },
  { id: 'nightlife', label: 'Soirée & Bar', icon: 'Wine' },
  { id: 'food', label: 'Resto & Food', icon: 'UtensilsCrossed' },
  { id: 'coworking', label: 'Coworking', icon: 'Laptop' },
  { id: 'language-exchange', label: 'Échange linguistique', icon: 'Languages' },
  { id: 'other', label: 'Autre', icon: 'Sparkles' },
];
